import {
  AdminSubmissionManagement,
  UserSubmissionManagement,
} from 'pages/submissions/components';

import { useCanAccess } from 'hooks/useCanAccess';
import { Unauthorized } from 'components/unauthorized';
import { TokenExpired } from 'components/tokenExpired';

export const SubmissionManagementRoute = () => {
  const { canAccess, isAdmin, isExpired } = useCanAccess('submissions');

  return isExpired ? (
    <TokenExpired />
  ) : isAdmin ? (
    <AdminSubmissionManagement />
  ) : canAccess ? (
    <UserSubmissionManagement />
  ) : (
    <Unauthorized />
  );
};
